import React from "react";

// react meta tags
import { ReactTitle } from "react-meta-tags";

// react redux
import { connect } from "react-redux";

// themes
import { Theme1 } from "./themes";

function Home(props) {
    // props
    const { globalAppTheme } = props;
    return (
        <React.Fragment>
            {/* website title */}
            <ReactTitle title={"Home Decor, Vases, Candleholders &amp; Outdoor Living | krave Decor"} />

            {globalAppTheme === "theme1" ? <Theme1 /> : null}
        </React.Fragment>
    );
}

const getDataFromStore = (state) => {
    return {
        globalAppTheme: state.common.globalAppTheme,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {};
};

export default connect(getDataFromStore, dispatchActionsToProps)(Home);
